import * as React from "react";
import { useSelector } from "react-redux";

import { Loader, Grid, Menu, Segment, Button, Card } from "semantic-ui-react";

import { Detail } from "@neworbit/simpleui-detail";
import { Authorize } from "reauthorize";

import { ApplicationState } from "../../applicationState";
import { GenericCaseTypeApi } from "../GenericCaseTypeApi";

import { GenericCaseType } from "../models";
import { ADMIN_ROLES } from "../../auth";

import { EditGenericCaseType } from "./EditGenericCaseType";

import { Link, Fragment } from "redux-little-router";

export const GenericCaseTypeDetails: React.FunctionComponent = () => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const genericCaseTypeId = useSelector((state: ApplicationState) => state.router.params!.genericCaseTypeId);
    const [loading, setLoading] = React.useState(false);
    const [genericCaseType, setGenericCaseType] = React.useState<GenericCaseType>();

    React.useEffect(() => {
        (async () => {
            setLoading(true);
            setGenericCaseType(await GenericCaseTypeApi.get(genericCaseTypeId));
            setLoading(false);
        })();
    }, [genericCaseTypeId]);

    const path = useSelector((state: ApplicationState) => state.router.pathname);

    if (loading || genericCaseType === undefined) {
        return <Loader active />;
    }

    return (
        <>
            <Grid container className="nomargintop">
                <Grid.Row>
                    <Grid.Column>
                        <h1>{genericCaseType.name}</h1>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={3} as={Grid} padded>
                        <Grid.Column vertical as={Menu}>
                            <Menu.Item name="Generic Case Types" as={Link} href={"/genericCaseTypes"}>
                                All Generic Case Types
                            </Menu.Item>
                        </Grid.Column>
                    </Grid.Column>

                    <Grid.Column width={13}>
                        <Card fluid>
                            <Segment attached>
                                <Grid>
                                    <Detail label="Name" value={genericCaseType.name} />
                                    <Detail label="Active" value={genericCaseType.active ? "Yes" : "No"} />
                                    <Detail label="Available to Customer" value={genericCaseType.availableToCustomer ? "Yes" : "No"} />
                                </Grid>
                            </Segment>
                            <Segment attached>
                                <Authorize authorize={[ADMIN_ROLES.SYSTEM_ADMIN.name]}>
                                    <Button icon="pencil" content="Edit" floated="right" as={Link} href={`${path}/edit`} />
                                </Authorize>
                            </Segment>
                        </Card>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <Fragment forRoute="/edit">
                <EditGenericCaseType genericCaseType={genericCaseType} onSaved={setGenericCaseType} />
            </Fragment>
        </>
    );
};
